/* eslint-disable @typescript-eslint/no-empty-function */
// pls fix me

import { memo, useMemo } from 'react';
import { IconButton, Stack } from '@mui/material';

import { RemoveIcon } from '@/assets/icons';
import { PropertiesTitle } from '@/modules/common/components/PropertiesTitle';
import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';
import { NumberInput } from '@/modules/common/components/inputs';
import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { useOrderProfileStore } from '@/modules/orderProfile/store/useOrderProfileStore';

import { useActiveFlowStore } from '../../store/useActiveFlowStore';
import { DEFAULT_FLOW_LOADS_AMOUNT } from '../../consts';
import { LoadPerHourInput } from '../LoadPerHourInput';
import { FlowGraph } from '../FlowGraph';

const ActiveFlowComponent = () => {
  const { currentFlowSourceId, currentFlowType } = useActiveFlowStore();
  const { orderProfile } = useOrderProfileStore.getState();
  const getAreaById = useFloorplanDesignStore((state) => state.getAreaById);
  const getFlowStopById = useFloorplanDesignStore((state) => state.getFlowStopById);

  const name = useMemo(() => {
    if (!currentFlowSourceId) return null;
    const flowStop = getFlowStopById(currentFlowSourceId);
    if (flowStop) {
      return `${flowStop.name} - ?`;
    }

    const area = getAreaById(currentFlowSourceId);
    if (!area) return null;
    return `${area.name} - ?`;
  }, [currentFlowSourceId, getAreaById, getFlowStopById]);

  if (!currentFlowSourceId || !name) return null;

  return (
    <Stack spacing={1} sx={{ flexDirection: 'column', mb: 2 }}>
      <Stack direction='row' width='100%' alignItems='center'>
        <PropertiesTitle editable={false} fontSize={14} value={name} sx={{ flex: '1 1 auto' }} />
        <IconButton sx={{ marginY: 'auto', p: 0, flex: '0 0 auto' }} disabled>
          <RemoveIcon />
        </IconButton>
      </Stack>
      {!orderProfile ? (
        <PropertiesLabel
          labelRatio={70}
          i18nkey='interface:properties.flows.flow_info.total_loads.label'
        >
          <LoadPerHourInput
            id={currentFlowSourceId}
            totalNumLoads={DEFAULT_FLOW_LOADS_AMOUNT}
            disabled
          />
        </PropertiesLabel>
      ) : (
        <FlowGraph hourlyOrderCounts={[30]} />
      )}
      {currentFlowType === 'TRANSPORT' && (
        <PropertiesLabel labelRatio={70} skipFocus i18nkey='interface:properties.highway.vehicles'>
          <NumberInput
            value={-1}
            onChange={() => {}}
            clearButton={{
              text: 'All',
              value: -1,
            }}
            sx={{ width: '100%', float: 'right' }}
            disabled
          />
        </PropertiesLabel>
      )}
    </Stack>
  );
};

export const ActiveFlow = memo(ActiveFlowComponent);
